import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICreateCheckoutSessionResponse } from "../models/Stripe";
import { DefaultResponse } from "../models/system";
import { UsageType } from "../models/UsageType";

export default function useStripeCustom() {
  const { get, post, put, patch, del } = useApiHelper();
  const queryClient = useQueryClient();

  const createSession = useMutation({
    mutationFn: (body: any) => post<ICreateCheckoutSessionResponse>("/stripe/checkout/session", body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["stripe", "session"] });
    },
  });

  const validatePayment = useMutation({
    mutationFn: (body: any) => post<DefaultResponse>("/stripe/checkout/session/validate", body),
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: ["stripe", "session"] });
    },
  });

  const useGetProductByUsageType = (usageType: UsageType | null) => {
    return useQuery({
      queryKey: ["stripe", "product", usageType],
      queryFn: () => get<any>(`/stripe/product/${usageType}`),
      staleTime: 1000 * 60 * 10, // 10 minutes
    });
  };

  const useGetPriceByUsageType = (usageType: UsageType | null) => {
    return useQuery({
      queryKey: ["stripe", "price", usageType],
      queryFn: () => get<any>(`/stripe/product/${usageType}/price`),
      staleTime: 1000 * 60 * 10, // 10 minutes
    });
  };

  return {
    createSession,
    validatePayment,
    useGetProductByUsageType,
    useGetPriceByUsageType,
  }
}